export const CONTRACT_STATES = [
  { id: "KHOI_TAO", label: 'Khởi tạo'},
  { id: "DA_KY", label: 'Đã ký'},
  { id: "THUC_HIEN", label: 'Đang thực hiện'},
  { id: "CHOT_DEAL", label: 'Đã chốt Deal Flash Offer'},
  { id: "QUYET_TOAN", label: 'Quyết toán'},
  { id: "HOAN_TAT", label: 'Hoàn tất'}
]

export const CONSULTATION_STATUS = [
  { id: "unprocessed", label: 'Chưa xử lý', color: 'info' },
  { id: "processed", label: 'Đang chăm sóc', color: 'warning' },
  { id: "canceled", label: 'Đã hủy', color: 'danger' },
  { id: "pending", label: 'Đang phân phối', color: 'info' }
]
